import { TkOrderListing } from '../components/OrderTable/types.ts';
import { OrderTab } from '../types.ts';

export const getOrdersByTab = (orders: TkOrderListing[]): Record<OrderTab, TkOrderListing[]> => {
  const activeOrders: TkOrderListing[] = [];
  const archivedOrders: TkOrderListing[] = [];
  const completedOrders: TkOrderListing[] = [];
  const trainingOrders: TkOrderListing[] = [];

  orders.forEach((order) => {
    if (order.isArchived === true) {
      archivedOrders.push(order);
    } else if (order.isCompleted === true) {
      completedOrders.push(order);
    } else if (order.isTraining === true || order.isMock === true) {
      trainingOrders.push(order);
    } else {
      activeOrders.push(order);
    }
  });

  return {
    active: activeOrders,
    archived: archivedOrders,
    completed: completedOrders,
    training: trainingOrders,
  };
}
